export default __webpack_public_path__ + "static/media/home-reversed.89d9d3b8.svg";